import React from 'react';
import { Box } from '@mui/material';

/** Blue id chip shown under a session title, e.g. #81. */
export function SessionIdBadge({ sessionId }: { sessionId: number | string }) {
  const id = String(sessionId ?? '').trim();
  if (!id) return null;
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        mt: 0.4,
        px: 0.75,
        py: 0.1,
        borderRadius: '4px',
        bgcolor: '#2e62cc',
        color: '#fff',
        fontSize: 11,
        fontWeight: 700,
        lineHeight: 1.5,
        width: 'fit-content',
      }}
    >
      #{id}
    </Box>
  );
}
